<template>
	<router-view/>
</template>

<script>

export default {
	name: 'AppBase',
	components: {
	},
	mounted() {
		this.$store.commit('basic', {
			key: 'isInAppBase',
			value: true,
		});
	},
	beforeDestroy() {
		this.$store.commit('basic', {
			key: 'isInAppBase',
			value: false,
		});
	},
}
</script>
